import Alert from '@mui/material/Alert';
import type { SxProps } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { useDealRevenueModifiers } from '../hooks/useDealRevenueModifiers';

const CONTAINER_SX: SxProps = { mt: 1.5 };

export const PostAuctionDiscountInfo = () => {
  const { dealPostAuctionDiscount } = useDealRevenueModifiers();
  const { t } = useTranslation();

  const showAlert = dealPostAuctionDiscount !== null;

  return (
    showAlert && (
      <Alert severity="info" sx={CONTAINER_SX} data-test="deal-revenue-calculator-pad-info">
        {t('There is a deal pad overriding seat pads for this deal. To see the calculation, check price breakdown.')}
      </Alert>
    )
  );
};
